// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _permissionsNameMap = {
  NotSet: "NotSet",
  Home: "Home",
  DispositiviRead: "DispositiviRead",
  DispositiviReadAll: "DispositiviReadAll",
  DispositiviUpdateTrasferimenti: "DispositiviUpdateTrasferimenti",
  DispositivoCreate: "DispositivoCreate",
  DispositivoUpdate: "DispositivoUpdate",
  DispositivoGeneraCertificato: "DispositivoGeneraCertificato",
  DispositivoDelete: "DispositivoDelete",
  DispositiviReadManutenzioni: "DispositiviReadManutenzioni",
  DispositiviUpdateManutenzioni: "DispositiviUpdateManutenzioni",
  DispositivoRegistriRead: "DispositivoRegistriRead",
  DispositivoRegistriWrite: "DispositivoRegistriWrite",
  DispositiviDatiStoriciRead: "DispositiviDatiStoriciRead",
  DispositiviDatiStoriciReadAll: "DispositiviDatiStoriciReadAll",
  DispositiviAlertValuesEdit: "DispositiviAlertValuesEdit",
  DispositiviAlertInternalUserOptionsEdit:
    "DispositiviAlertInternalUserOptionsEdit",
  DispositiviUpdateReminders: "DispositiviUpdateReminders",
  AziendeReadAll: "AziendeReadAll",
  AziendeRead: "AziendeRead",
  AziendaRead: "AziendaRead",
  AziendaCreate: "AziendaCreate",
  AziendaUpdate: "AziendaUpdate",
  AziendaEdit: "AziendaEdit",
  AziendaDelete: "AziendaDelete",
  ContenitoriRead: "CentraliRead",
  ContenitoriReadAll: "CentraliReadAll",
  ContenitoreCreate: "CentraleCreate",
  ContenitoreUpdate: "CentraleUpdate",
  ContenitoreUpdateAlloggiamentiFiltro: "CentraleUpdateAlloggiamentiFiltro",
  ContenitoreUpdateStoricoFiltri: "CentraleUpdateStoricoFiltri",
  ContenitoreUpdateStoricoOlio: "CentraleUpdateStoricoOlio",
  ContenitoreUpdateReminders: "CentraleUpdateReminders",
  ContenitoreUpdateBonifica: "CentraleUpdateBonifica",
  ContenitoreUpdateAnalisi: "CentraleUpdateAnalisi",
  ContenitoreUpdateFiltrazioni: "CentraleUpdateFiltrazioni",
  ContenitoreUpdateImmagini: "CentraleUpdateImmagini",
  ContenitoreDelete: "CentraleDelete",
  GatewayRead: "GatewayRead",
  GatewayReadAll: "GatewayReadAll",
  GatewayCreate: "GatewayCreate",
  GatewayUpdate: "GatewayUpdate",
  GatewayDelete: "GatewayDelete",
  RipetitoreRead: "RipetitoreRead",
  RipetitoreReadAll: "RipetitoreReadAll",
  RipetitoreCreate: "RipetitoreCreate",
  RipetitoreUpdate: "RipetitoreUpdate",
  RipetitoreDelete: "RipetitoreDelete",
  GrafoRead: "GrafoRead",
  GrafoUpdate: "GrafoUpdate",
  TrasferimentiChange: "TrasferimentiChange",
  ConnessioneGatewayChange: "ConnessioneGatewayChange",
  UsersInterniRead: "UsersInterniRead",
  UsersEsterniRead: "UsersEsterniRead",
  UsersInterniChange: "UsersInterniChange",
  UsersEsterniChange: "UsersEsterniChange",
  ModelliFiltroChange: "ModelliFiltroChange",
  ModelliOlioChange: "ModelliOlioChange",
  ModelliGatewayChange: "ModelliGatewayChange",
  DescrizioniBonificaChange: "DescrizioniBonificaChange",
  DescrizioniManutenzioneChange: "DescrizioniManutenzioneChange",
  ModelliDispositivoChange: "ModelliDispositivoChange",
  NodoIconeChange: "NodoIconeChange",
  FileUpload: "FileUpload",
  AnalisiListaReadAll: "AnalisiListaReadAll",
  AnalisiListaRead: "AnalisiListaRead",
  FiltrazioniListaReadAll: "FiltrazioniListaReadAll",
  FiltrazioniListaRead: "FiltrazioniListaRead",
  BonificheListaReadAll: "BonificheListaReadAll",
  BonificheListaRead: "BonificheListaRead",
  CalendarioInterventiRead: "CalendarioInterventiRead",
  CalendarioTrasferimentiRead: "CalendarioTrasferimentiRead",
  RuoliPermessiRead: "RuoliPermessiRead",
  RuoliPermessiUpdate: "RuoliPermessiUpdate",
  RichiestePreventivoRead: "RichiestePreventivoRead",
  RichiestePreventivoReadAll: "RichiestePreventivoReadAll",
  RichiestePreventivoUpdate: "RichiestePreventivoUpdate",
  RichiestePreventivoDelete: "RichiestePreventivoDelete",
} as const;
